import { http } from '../utils/http';
import Store from '@/store/';

// 获取日志列表
export const reqFetchLogs = params =>
  http.request({
    url: `/log`,
    method: 'GET',
    params
  });

// 判断日志名称是否已经存在
export const reqJudgeLog = params =>
  http.request({
    url: `/log/judge`,
    method: 'GET',
    params,
    withUserId: 'PARAMS'
  });

// 创建日志库
export const reqCreateLog = data =>
  http.request({
    timeout: '20000',
    url: `/log`,
    method: 'POST',
    data
  });

// 编辑日志库
export const reqUpdateLog = data =>
  http.request({
    url: `/log`,
    method: 'PUT',
    data
  });

// 查询日志库详情
export const reqShowLog = logId =>
  http.request({
    url: `/log/${logId}`,
    method: 'GET'
  });

// 删除日志库
export const reqDestroyLog = params =>
  http.request({
    url: `/log`,
    method: 'DELETE',
    params
  });

// 获取 Kibana 的用户名和密码
export const reqFetchKibanaUserInfo = () =>
  http.request({
    url: `/log/show/${Store.getters['user/userId']}`,
    method: 'GET'
  });

// 解析正则表达式符样例日志
export const reqFetchParsePattern = data =>
  http.request({
    url: `/log/parse/pattern`,
    method: 'POST',
    data
  });

// 添加日志解析配置
export const reqCreateRule = data =>
  http.request({
    url: `/log/rule`,
    method: 'POST',
    data,
    withUserId: 'DATA'
  });

// 根据日志id 和数据源id 判断是否存在数据源
export const reqFetchDataSource = params =>
  http.request({
    url: `/log/dataSource`,
    method: 'GET',
    params
  });

// 根据日志id 查询规则名称列表
export const reqFetchParseRules = params =>
  http.request({
    url: `/log/parseRule`,
    method: 'GET',
    params
  });

// 根据规则id 查询根据该规则接入的日志规则配置和日志接入指南
export const reqShowRuleDetail = params =>
  http.request({
    url: `/log/rule/detail`,
    method: 'GET',
    params
  });

// 判断规则名称是否已经存在
export const reqJudgeRule = params =>
  http.request({
    url: `/log/rule/judge`,
    method: 'GET',
    params
  });
